import { ApiError } from "../services/apiError.js";

/** The sentence the server answers with when the library does not have Thrive. */
export const THRIVE_NOT_ENABLED_MESSAGE = "Thrive is not turned on for this library.";

/**
 * Broadcast by the API client when any Thrive request is refused for that
 * reason, so the Thrive shell can show its "Thrive is not enabled" state
 * instead of whichever screen asked (the same pattern as the read-only
 * impersonation refusal): no screen has to remember to check. The detail
 * carries the library chosen when the request was sent (`clientId`), so a
 * late refusal for the library staff have since left is ignored.
 */
export const THRIVE_NOT_ENABLED_EVENT = "cos:thrive-not-enabled";

/**
 * True when the server refused a request because the library does not have
 * Thrive (403 with that exact sentence), as opposed to any other 403.
 */
export function isThriveNotEnabledError(e: unknown): boolean {
	return e instanceof ApiError && e.status === 403 && e.message === THRIVE_NOT_ENABLED_MESSAGE;
}
